import React from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../contexts/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
    const navigate = useNavigate();
    const [sp] = useSearchParams();
    const { login } = useAuth();
    const [form, setForm] = React.useState({ email: "", password: "" });
    const [loading, setLoading] = React.useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const u = await login(form.email, form.password);
            toast.success("Autentificat cu succes!");
            const next = sp.get("next");
            if (next) {
                navigate(next);
            } else {
                // Smart redirect by role: staff → admin panel; installer → tickets directly; client → cont
                const role = u?.role;
                if (role === "installer") navigate("/admin/tickets");
                else if (["superadmin", "admin", "sales"].includes(role)) navigate("/admin");
                else navigate("/cont");
            }
        } catch (err) {
            toast.error(err.response?.data?.detail || "Eroare la autentificare");
        } finally {
            setLoading(false);
        }
    };

    const googleLogin = () => {
        const params = new URLSearchParams({
            client_id: "1069516180999-lmniifgqpgsddvghvl4capmrp8djobgb.apps.googleusercontent.com",
            redirect_uri: "https://ccashop.ro/cont",
            response_type: "code",
            scope: "openid email profile",
            access_type: "online",
            prompt: "select_account",
        });
        window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${params}`;
    };

    return (
        <div className="container-x py-20 max-w-md mx-auto" data-testid="login-page">
            <h1 className="font-heading text-4xl uppercase mb-6">Bine ai revenit</h1>
            <form onSubmit={submit} className="space-y-3">
                <input required type="email" placeholder="Email" value={form.email} onChange={(e) => setForm(f => ({ ...f, email: e.target.value }))} className="w-full px-3 py-3 border-2 border-foreground bg-transparent" data-testid="login-email" />
                <input required type="password" placeholder="Parolă" value={form.password} onChange={(e) => setForm(f => ({ ...f, password: e.target.value }))} className="w-full px-3 py-3 border-2 border-foreground bg-transparent" data-testid="login-password" />
                <div className="flex justify-end">
                    <Link to="/reset-parola" className="text-xs text-muted-foreground hover:text-primary" data-testid="login-forgot">Ai uitat parola?</Link>
                </div>
                <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="login-submit">{loading ? "..." : "Autentificare"}</button>
            </form>
            <div className="my-6 flex items-center gap-4">
                <div className="flex-1 h-px bg-border" />
                <span className="font-mono text-xs uppercase text-muted-foreground">sau</span>
                <div className="flex-1 h-px bg-border" />
            </div>
            <button onClick={googleLogin} className="btn-outline w-full" data-testid="login-google">Continuă cu Google</button>
            <p className="mt-6 text-center text-sm text-muted-foreground">
                Nu ai cont? <Link to="/register" className="text-primary font-medium" data-testid="login-to-register">Creează unul</Link>
            </p>
        </div>
    );
}
